import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export type TableCellProps = ComponentProps<'td'>;
export const TABLE_CELL_HEIGHT_CLASS = 'h-[49px]';
export const TABLE_CELL_PADDING_CLASS = 'p-2';

const TableCell = ({ className, ...props }: TableCellProps) => {
  return (
    <td
      data-slot="table-cell"
      className={cn(
        TABLE_CELL_HEIGHT_CLASS,
        TABLE_CELL_PADDING_CLASS,
        'align-middle whitespace-normal wrap-break-word',
        className,
      )}
      {...props}
    />
  );
};

export default TableCell;
